'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('flickity/dist/flickity.min.css');

require('flickity-imagesloaded');

require('flickity-as-nav-for');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _GiftBox = require('../models/global/GiftBox');

var _GiftBox2 = _interopRequireDefault(_GiftBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var mainSliderEl = document.querySelector('.js-mainSlider');
  var mainSlider = new _flickity2.default(mainSliderEl, {
    cellAlign: 'left',
    contain: true,
    adaptiveHeight: true,
    prevNextButtons: false,
    imagesLoaded: true
  });

  var navSliderEl = document.querySelector('.js-navSlider');
  var navSlider = new _flickity2.default(navSliderEl, {
    asNavFor: mainSliderEl,
    contain: true,
    pageDots: false,
    imagesLoaded: true
  });

  var inputs = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.js-input')));
  var frequency = document.querySelector('.js-frequency');
  var submit = document.querySelector('.js-submit');
  var inputContainers = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.js-inputContainer')));

  var _loop = function _loop(input) {
    input.addEventListener('change', function () {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = inputContainers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var inputContainer = _step2.value;

          inputContainer.classList.remove('is-selected');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      input.parentElement.classList.add('is-selected');
    });
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var input = _step.value;

      _loop(input);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var giftBox = new _GiftBox2.default();

  submit.addEventListener('click', function () {
    var selectedInput = inputs.find(function (input) {
      return input.checked === true;
    });
    if (selectedInput.id === 'one-time') {
      var properties = giftBox.getSelectedProducts();
      window.cart.addToCart(selectedInput.value, 1, properties);
    } else {
      var _properties = {
        "shipping_interval_frequency": frequency.value,
        "shipping_interval_unit_type": selectedInput.getAttribute('data-int-unit')
      };
      window.cart.addToCart(selectedInput.value, 1, _properties);
    }
  });
});